import type { QueryClient } from '@tanstack/react-query';

// These queries jointly render total cash, source locks, audit progress and
// withdrawal quotes. Never refresh only /me after a wallet transaction.
export function refreshWalletFinancials(client: QueryClient, token: string) {
  return Promise.all(['me', 'wallet-bonus-audit', 'wallet-bonus-audit-records', 'wallet-withdrawal-eligibility']
    .map((key) => client.invalidateQueries({ queryKey: [key, token] })));
}

export function refreshWallet(client: QueryClient, token: string) {
  return Promise.all([
    client.invalidateQueries({ queryKey: ['wallet', token] }),
    refreshWalletFinancials(client, token),
  ]);
}
